export const API = "https://api.nihongonomemo.fr";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";
